import React from "react";
import MemberForm from "../components/MemberForm";
import GroupForm from "../components/GroupForm";

import ActivateMemberForm from "../components/ActivateMemberForm";

import axios from "axios";
import {
  Table,
  Input,
  Button,
  Collapse,
  Popover,
  Popconfirm,
  message,
  Descriptions,
  Modal,
  Spin,
  Card,
  Tabs,
  Form,
  Select,
  Switch,
  Tag,
} from "antd";
import Highlighter from "react-highlight-words";
import Icon from "@ant-design/icons";
import {
  SearchOutlined,
  DeleteOutlined,
  SwapOutlined,
  FundViewOutlined,
  DownloadOutlined,
  EditOutlined,
  WalletFilled,
  LoadingOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import CurrencyFormat from "react-currency-format";
import * as serverconfig from "../serverconn";
import {
  ACCOUNT_STATUS_OPTIONS,
  buildMembersApiQuery,
  filterMembers,
  hasActiveMemberFilters,
} from "../memberListFilters";
import { Col, Row } from "reactstrap";
import ReactExport from "@ibrahimrahmani/react-export-excel";
import LoanIssuanceListPerMember from "./LoanIssuancesListViewPerMember";
import FinancialStatementReportPerMember from "./FinancialStatementReportViewPerMember";
import MemberDetail from "./MemberDetailView";
import QuickActions from "../components/QuickActions";

var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const { Option } = Select;

function callback(key) {
  console.log(key);
}

const { TabPane } = Tabs;
const FormItem = Form.Item;
const { Search } = Input;

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

var sacco = "";
var bizuserid = "";
var bizuserid = "";
var token = "";

class MemberList extends React.Component {
  state = {
    searchText: "",
    searchedColumn: "",
    members: [],
    members_placeholders: [],

    viewpaymentmodal: false,
    expensedetails: {},
    userprofile: {},
    datarequested: true,
    memberactivationformvisible: false,
    selectedmemberid: "",
    userrights: {},
    current_selected_member: "",
    loan_particular_data_loading: false,

    groupconvermodal_visible: false,
    selected_member: "",
    selected_new_member_type:'',
    membertypes:[],
    selectedRowKeys: [],
    batchDeleteLoading: false,
    isBranchManager: false,
    filterSearch: '',
    filterGender: '',
    filterMemberTypeId: '',
    filterAccountStatus: '',
    filterAccountKind: 'all',
    filterHasLoan: 'all',
    filterHasSavings: 'all',
    filterZeroBalancesOnly: false,
    membersLoading: false,
  };

  componentDidMount() {
    this.componentmountactions();
  }

  //component mount method
  componentmountactions = () => {

    if (localStorage.getItem("sacco")) {
      sacco = CryptoJS.AES.decrypt(
        localStorage.getItem("sacco"),
        "my-secret-key@12345"
      ).toString(CryptoJS.enc.Utf8);
      bizuserid = CryptoJS.AES.decrypt(
        localStorage.getItem("bizuserid"),
        "my-secret-key@1234"
      ).toString(CryptoJS.enc.Utf8);
    } else {
      sacco = "";
      bizuserid = "";
    }

    if (localStorage.getItem("bizuserid")) {
      bizuserid = CryptoJS.AES.decrypt(
        localStorage.getItem("bizuserid"),
        "my-secret-key@1234"
      ).toString(CryptoJS.enc.Utf8);
    } else {
      bizuserid = "";
    }

    if (localStorage.getItem("token")) {
      token = localStorage.getItem("token");
    } else {
      token = "";
    }

    axios.defaults.headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    };

    this.setState({ membersLoading: true });

    axios
      .get(
        `${serverconfig.backendserverurl}/api/members_dataview/?${buildMembersApiQuery(sacco, {})}`
      )
      .then((res) => {
        const allMembers = res.data || [];
        this.setState(
          {
            members_placeholders: allMembers,
          },
          () => this.applyMemberFilters(allMembers)
        );
      })
      .finally(() => {
        this.setState({ membersLoading: false });
      });

    axios
      .get(
        serverconfig.backendserverurl + `/api/accountrights/?user=${bizuserid}`
      )
      .then((res) => {
        this.setState({
          userrights: res.data[0],
        });
        this.setState({ datarequested: false });
      });


      axios.get(serverconfig.backendserverurl+`/api/membertypes/?sacco=${sacco}`)
      .then(res => {
          this.setState({
            membertypes:res.data
          })
      })

    if (bizuserid) {
      axios
        .get(`${serverconfig.backendserverurl}/api/accounts/${bizuserid}/`)
        .then((res) => {
          const userprofile = res.data || {};
          this.setState({
            userprofile,
            isBranchManager: userprofile.branch_manager === true,
          });
        })
        .catch(() => {
          this.setState({ userprofile: {}, isBranchManager: false });
        });
    }
  };

  canDeleteMembers = () => this.state.isBranchManager === true;

  getMemberFilters = () => ({
    searchText: this.state.filterSearch,
    gender: this.state.filterGender,
    memberTypeId: this.state.filterMemberTypeId,
    accountStatus: this.state.filterAccountStatus,
    accountKind: this.state.filterAccountKind,
    hasLoan: this.state.filterHasLoan,
    hasSavings: this.state.filterHasSavings,
    zeroBalancesOnly: this.state.filterZeroBalancesOnly,
  });

  applyMemberFilters = (sourceMembers) => {
    const base = sourceMembers || this.state.members_placeholders;
    const filtered = filterMembers(base, this.getMemberFilters());
    this.setState({
      members: filtered,
      selectedRowKeys: [],
    });
  };

  updateMemberFilter = (patch, callback) => {
    this.setState(patch, () => {
      this.applyMemberFilters();
      if (callback) {
        callback();
      }
    });
  };

  clearMemberFilters = () => {
    this.setState(
      {
        filterSearch: '',
        filterGender: '',
        filterMemberTypeId: '',
        filterAccountStatus: '',
        filterAccountKind: 'all',
        filterHasLoan: 'all',
        filterHasSavings: 'all',
        filterZeroBalancesOnly: false,
      },
      () => this.applyMemberFilters()
    );
  };

  reloadMembersFromServer = () => {
    this.setState({ membersLoading: true });
    const filters = this.getMemberFilters();
    const hasFilters = hasActiveMemberFilters(filters);
    const query = buildMembersApiQuery(sacco, hasFilters ? filters : {});

    axios
      .get(`${serverconfig.backendserverurl}/api/members_dataview/?${query}`)
      .then((res) => {
        const rows = res.data || [];
        if (hasFilters) {
          this.setState({ members: rows, selectedRowKeys: [] });
          return;
        }

        this.setState(
          {
            members_placeholders: rows,
            selectedRowKeys: [],
          },
          () => this.applyMemberFilters(rows)
        );
      })
      .finally(() => {
        this.setState({ membersLoading: false });
      });
  };

  //////////////////////////////////////////////////
  //handle delete here
  handleDelete = (id) => {
    if (!this.canDeleteMembers()) {
      message.error("Only branch managers can delete member accounts.");
      return;
    }

    const form_data1 = new FormData();
    form_data1.append("memberid", id);
    form_data1.append("sacco", sacco);
    if (bizuserid) {
      form_data1.append("user_id", bizuserid);
    }

    axios
      .post(
        `${serverconfig.backendserverurl}/customqueries/deletemember`,
        form_data1,
        {
          headers: {
            "content-type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        message.success(res.data.message || "Member deleted.");
        this.componentmountactions();
      })
      .catch((err) => {
        const msg =
          (err.response && err.response.data && err.response.data.message) ||
          "Could not delete member.";
        message.error(msg);
      });
  };

  handleBatchDelete = () => {
    if (!this.canDeleteMembers()) {
      message.error("Only branch managers can delete member accounts.");
      return;
    }

    const { selectedRowKeys } = this.state;
    if (!selectedRowKeys.length) {
      message.warning("Select at least one member account.");
      return;
    }

    this.setState({ batchDeleteLoading: true });
    const form_data = new FormData();
    form_data.append("sacco", sacco);
    form_data.append("member_ids", JSON.stringify(selectedRowKeys));
    if (bizuserid) {
      form_data.append("user_id", bizuserid);
    }

    axios
      .post(
        `${serverconfig.backendserverurl}/customqueries/batch_deletemembers`,
        form_data,
        {
          headers: {
            "content-type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        const data = res.data || {};
        if (data.deleted_count > 0) {
          message.success(data.message);
        } else {
          message.error(data.message || "No members were deleted.");
        }
        if (data.blocked_count > 0) {
          const preview = (data.blocked || [])
            .slice(0, 5)
            .map((row) => `${row.account || row.member_id}: ${row.reason}`)
            .join(" | ");
          message.warning(
            `${data.blocked_count} account(s) skipped (have transactions or balances). ${preview}`
          );
        }
        this.setState({ selectedRowKeys: [], batchDeleteLoading: false });
        this.componentmountactions();
      })
      .catch((err) => {
        const msg =
          (err.response && err.response.data && err.response.data.message) ||
          "Batch delete failed.";
        message.error(msg);
        this.setState({ batchDeleteLoading: false });
      });
  };

  onSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };

  //open mdi guarantor form
  openmemberactivationform = (val) => {
    this.setState({ selectedmemberid: val });
    this.setState({ memberactivationformvisible: true });
  };

  closememberactivationform = () => {
    this.setState({ memberactivationformvisible: false });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) => {
      const raw = record[dataIndex];
      if (raw === undefined || raw === null) {
        return false;
      }
      return String(raw).toLowerCase().includes(value.toLowerCase());
    },

    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  render() {
    var columns = [
      {
        title: "Account Number",
        dataIndex: "AccountNumber",
        key: "id",
        ...this.getColumnSearchProps("AccountNumber"),
        sorter: (a, b) => a.AccountNumber.localeCompare(b.AccountNumber),
      },
      {
        title: "Account Name",
        dataIndex: "FullName",
        key: "id",
        ...this.getColumnSearchProps("FullName"),
      },
      {
        title: "Gender",
        dataIndex: "gender",
        key: "id",
        ...this.getColumnSearchProps("gender"),
      },
      {
        title: "Member Type",
        dataIndex: "membertypename",
        key: "id",
        ...this.getColumnSearchProps("membertypename"),
      },
      {
        title: "Account Contact",
        dataIndex: "RegisteredPhoneNumber1",
        key: "id",
        ...this.getColumnSearchProps("RegisteredPhoneNumber1"),
      },
      {
        title: "Email Address",
        dataIndex: "EmailAddress",
        key: "id",
        ...this.getColumnSearchProps("EmailAddress"),
        render: (text, record) => (
          <div>
            <p>{text}</p>
            <p>
              Email receiver: {record.email_statements === true ? "Yes" : "No"}
            </p>
          </div>
        ),
      },
      {
        title: "Account Status",
        dataIndex: "account_status",
        key: "id",
        ...this.getColumnSearchProps("account_status"),
      },

      {
        title: "Date of joining",
        dataIndex: "DateOfJoining",
        key: "id",
        ...this.getColumnSearchProps("DateOfJoining"),
      },
      {
        title: "Savings balance",
        dataIndex: "savings_balance",
        key: "id",
        render: (text) => (
          <CurrencyFormat
            value={text}
            displayType={"text"}
            thousandSeparator={true}
          />
        ),
      },
      {
        title: "Shares amount",
        dataIndex: "sharesamount_balance",
        key: "id",
        render: (text) => (
          <CurrencyFormat
            value={text}
            displayType={"text"}
            thousandSeparator={true}
          />
        ),
      },
      {
        title: "Loan balance",
        dataIndex: "loan_balance",
        key: "id",
        render: (text) => (
          <CurrencyFormat
            value={text}
            displayType={"text"}
            thousandSeparator={true}
          />
        ),
      },
      {
        title: "Created by",
        dataIndex: "created_by",
        key: "id",
      },
      {
        title: "Action",
        dataIndex: "id",
        key: "id",
        render: (text, record) => (
          <p>
            {this.state.userrights.accountactivation ? (
              <Popover
                content={<p>Click here to change account status ID {record.id}</p>}
                title="Change status"
              >
                <EditOutlined
                  style={{ color: "green" }}
                  onClick={() => {
                    this.openmemberactivationform(text);
                  }}
                />
              </Popover>
            ) : null}
            &nbsp;&nbsp;&nbsp;
            <Popover
              content={<p>Click here to go to quick menu </p>}
              title="Quick menu"
            >
              <Link to={`/quickmenu/`}>
                <UnorderedListOutlined style={{ color: "blue" }} />
              </Link>
            </Popover>
            &nbsp;&nbsp;&nbsp;

            {this.canDeleteMembers() ? (
              <Popover
                content={
                  <p>
                    Delete only if the account has no transactions, loans, or balances
                  </p>
                }
                title="Delete"
              >
                <Popconfirm
                  title="Delete this member? Only allowed when there are no transactions."
                  onConfirm={() => this.handleDelete(text)}
                >
                  <DeleteOutlined style={{ color: "red" }} />
                </Popconfirm>
              </Popover>
            ) : null}
            &nbsp;&nbsp;&nbsp;




            {record.groupAccount === false ? (
              <Popover
                content={<p>Click here to convert to group/joint account</p>}
                title="Convert to group"
              >
                <SwapOutlined
                  onClick={() => {
                    this.setState({ selected_member: record.id });
                    this.setState({ groupconvermodal_visible: true });
                  }}
                  style={{ color: "green" }}
                />
              </Popover>
            ) : null}
          </p>
        ),
      },
    ];

    if (this.state.datarequested === true) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin size="large">
            <div className="content">
              <h3>Pisacco</h3>
            </div>
          </Spin>
        </div>
      );
    } else {
      return (
        <div>
          <Collapse defaultActiveKey={["1"]} onChange={this.callback}>
            <Panel
              header={
                <h4 style={{ fontWeight: "bolder" }}>
                  AVAILABLE MEMBER ACCOUNTS
                </h4>
              }
              key="1"
            >
              <ExcelFile
                filename={"Pisacco - All Members list"}
                element={
                  <Button type="primary" icon={<DownloadOutlined />}>
                    Download Excel Total ({this.state.members.length})
                  </Button>
                }
              >
                <ExcelSheet data={this.state.members} name="All members list">
                  <ExcelColumn label="Acc No" value="AccountNumber" />
                  <ExcelColumn label="Acc Name" value="FullName" />
                  <ExcelColumn label="Member type" value="membertypename" />
                  <ExcelColumn
                    label="Member Contact"
                    value="RegisteredPhoneNumber1"
                  />

                  <ExcelColumn label="Savings" value="savings_balance" />
                  <ExcelColumn
                    label="Shares number"
                    value="sharesnumber_balance"
                  />
                  <ExcelColumn
                    label="Shares amount"
                    value="sharesamount_balance"
                  />
                  <ExcelColumn label="Loan balance" value="loan_balance" />
                  <ExcelColumn
                    label="Loan interest"
                    value="loaninterest_balance"
                  />

                  <ExcelColumn
                    label="Savings reserve"
                    value="savingsloan_security_balance"
                  />
                  <ExcelColumn
                    label="Fixed deposit balance"
                    value="fixed_deposit_balance"
                  />
                  <ExcelColumn label="Loan fine" value="loanfine_balance" />
                  <ExcelColumn label="Created by " value="created_by" />
                </ExcelSheet>
              </ExcelFile>

              <br></br>
              <br></br>

              <Form layout="inline" style={{ marginBottom: 12, rowGap: 8 }}>
                <FormItem label="Search">
                  <Search
                    allowClear
                    placeholder="Account no, name, phone, email, ID, district…"
                    value={this.state.filterSearch}
                    onChange={(e) => this.updateMemberFilter({ filterSearch: e.target.value })}
                    style={{ width: 320, margin: 5 }}
                  />
                </FormItem>

                <FormItem label="Gender">
                  <Select
                    allowClear
                    placeholder="Any"
                    value={this.state.filterGender || undefined}
                    onChange={(value) => this.updateMemberFilter({ filterGender: value || '' })}
                    style={{ width: 120, margin: 5 }}
                  >
                    <Option value="Male">Male</Option>
                    <Option value="Female">Female</Option>
                  </Select>
                </FormItem>

                <FormItem label="Member type">
                  <Select
                    allowClear
                    showSearch
                    optionFilterProp="children"
                    placeholder="Any type"
                    value={this.state.filterMemberTypeId || undefined}
                    onChange={(value) => this.updateMemberFilter({ filterMemberTypeId: value || '' })}
                    style={{ width: 180, margin: 5 }}
                  >
                    {this.state.membertypes.map((typeRow) => (
                      <Option key={typeRow.id} value={String(typeRow.id)}>
                        {typeRow.type_name}
                      </Option>
                    ))}
                  </Select>
                </FormItem>

                <FormItem label="Status">
                  <Select
                    allowClear
                    placeholder="Any status"
                    value={this.state.filterAccountStatus || undefined}
                    onChange={(value) => this.updateMemberFilter({ filterAccountStatus: value || '' })}
                    style={{ width: 130, margin: 5 }}
                  >
                    {ACCOUNT_STATUS_OPTIONS.map((opt) => (
                      <Option key={opt.value} value={opt.value}>
                        {opt.label}
                      </Option>
                    ))}
                  </Select>
                </FormItem>

                <FormItem label="Account kind">
                  <Select
                    value={this.state.filterAccountKind}
                    onChange={(value) => this.updateMemberFilter({ filterAccountKind: value })}
                    style={{ width: 150, margin: 5 }}
                  >
                    <Option value="all">All accounts</Option>
                    <Option value="individual">Individuals only</Option>
                    <Option value="group">Groups / joint only</Option>
                  </Select>
                </FormItem>

                <FormItem label="Has loan">
                  <Select
                    value={this.state.filterHasLoan}
                    onChange={(value) => this.updateMemberFilter({ filterHasLoan: value })}
                    style={{ width: 110, margin: 5 }}
                  >
                    <Option value="all">Any</Option>
                    <Option value="yes">Yes</Option>
                    <Option value="no">No</Option>
                  </Select>
                </FormItem>

                <FormItem label="Has savings">
                  <Select
                    value={this.state.filterHasSavings}
                    onChange={(value) => this.updateMemberFilter({ filterHasSavings: value })}
                    style={{ width: 110, margin: 5 }}
                  >
                    <Option value="all">Any</Option>
                    <Option value="yes">Yes</Option>
                    <Option value="no">No</Option>
                  </Select>
                </FormItem>

                <FormItem label="Zero balances">
                  <Switch
                    checked={this.state.filterZeroBalancesOnly}
                    onChange={(checked) => this.updateMemberFilter({ filterZeroBalancesOnly: checked })}
                  />
                </FormItem>

                <FormItem>
                  <Button onClick={this.clearMemberFilters} style={{ margin: 5 }}>
                    Clear filters
                  </Button>
                </FormItem>

                <FormItem>
                  <Button type="default" loading={this.state.membersLoading} onClick={this.reloadMembersFromServer} style={{ margin: 5 }}>
                    Refresh from server
                  </Button>
                </FormItem>
              </Form>

              <div style={{ marginBottom: 12 }}>
                <Tag color="blue">
                  Showing {this.state.members.length} of {this.state.members_placeholders.length} members
                </Tag>
                {hasActiveMemberFilters(this.getMemberFilters()) ? (
                  <Tag color="gold">Filters active</Tag>
                ) : null}
              </div>

              <br></br>
              <br></br>

              <Popconfirm
                title="Delete selected members with no transactions?"
                onConfirm={this.handleBatchDelete}
                disabled={!this.state.selectedRowKeys.length || !this.canDeleteMembers()}
              >
                {this.canDeleteMembers() ? (
                  <Button
                    type="danger"
                    icon={<DeleteOutlined />}
                    loading={this.state.batchDeleteLoading}
                    disabled={!this.state.selectedRowKeys.length}
                    style={{ marginBottom: 16 }}
                  >
                    Delete selected ({this.state.selectedRowKeys.length}) — branch manager only
                  </Button>
                ) : null}
              </Popconfirm>

              <Table
                rowKey="id"
                rowSelection={
                  this.canDeleteMembers()
                    ? {
                        selectedRowKeys: this.state.selectedRowKeys,
                        onChange: this.onSelectChange,
                      }
                    : undefined
                }
                columns={columns}
                size="small"
                scroll={{ x: 1000 }}
                dataSource={this.state.members}
                pagination={{ showQuickJumper: true, showSizeChanger: true }}
                bordered
                expandable={{
                  expandedRowRender: (record) => {
                    if (
                      Number(record.id) ===
                      Number(this.state.current_selected_member)
                    ) {
                      return (
                        <div
                          style={{
                            margin: 0,
                          }}
                        >
                          {this.state.loan_particular_data_loading === true ? (
                            <div style={{ display: "flex", margin: 20 }}>
                              <Spin indicator={antIcon} />
                            </div>
                          ) : (
                            <Tabs defaultActiveKey="1" onChange={callback}>
                              <TabPane tab="View,edit details" key="03">
                                <MemberDetail memberID={record.id} />
                              </TabPane>

                              <TabPane tab="Financial statement" key="02">
                                <FinancialStatementReportPerMember
                                  member_id={record.id}
                                />
                              </TabPane>
                              <TabPane tab="Member loans" key="01">
                                <LoanIssuanceListPerMember
                                  member_id={record.id}
                                />
                              </TabPane>

                              <TabPane tab="More Actions" key="04">
                                <QuickActions memberobj={record} onRefresh={this.componentmountactions}/>
                              </TabPane>


                            </Tabs>
                          )}
                        </div>
                      );
                    } else {
                      return null;
                    }
                  },
                  rowExpandable: (record) =>
                    record.id !== this.state.current_selected_member.id,
                  onExpand: (condition, record) => {
                    this.setState({ loan_particular_data_loading: false });

                    //set curent id
                    this.setState({ current_selected_member: record.id });
                  },
                }}
              />
              <br />
            </Panel>
          </Collapse>
          <br></br>

          <Card>
            <h5
              style={{
                justifyContent: "start",
                display: "flex",
                color: "green",
              }}
            >
              Member creation form
            </h5>
            <MemberForm requestType="post" expenseID={null} btnText="Create" />
          </Card>

          <Modal
            visible={this.state.memberactivationformvisible}
            title={"Account status Form"}
            onCancel={this.closememberactivationform}
            style={{ width: 1000 }}
            footer={[
              <Button key="back" onClick={this.closememberactivationform}>
                Cancel
              </Button>,
            ]}
          >
            <ActivateMemberForm memberid={this.state.selectedmemberid} />
          </Modal>

          <Modal
            visible={this.state.groupconvermodal_visible}
            title={"Group/Joint conversion Form"}
            onCancel={() => {
              this.setState({ groupconvermodal_visible: false });
            }}
            style={{ width: 1000 }}
            footer={[
              <Button
                key="back"
                onClick={() => {
                  this.setState({ groupconvermodal_visible: false });
                }}
              >
                Cancel
              </Button>,
            ]}
          >

            <FormItem label="New joint /group member type">
                      <Select placeholder="Member Type" style={{  }} 
                      value={this.state.selected_new_member_type} 
                      onChange={(e) => this.setState({ selected_new_member_type: e})} >
                        {this.state.membertypes.map(
                          (stf)=>(
                            <Option value={stf.id}>{stf.type_name}</Option>
                          ))}
                      </Select>
               </FormItem>


            <h4>Click to convert to group account</h4>
            <Button
              type="primary"
              onClick={() => {

                if (this.state.selected_new_member_type===""){
                  message.error("Please select new member type")
                }else{

                this.setState({ datarequested: true });

                let form_data1 = new FormData();
                form_data1.append("account", this.state.selected_member);
                form_data1.append("selected_new_member_type", this.state.selected_new_member_type);

                axios
                  .post(
                    serverconfig.backendserverurl +
                      "/customqueries/convertaccountto_group_joint",
                    form_data1,
                    {
                      headers: {
                        "content-type": "multipart/form-data",
                      },
                    }
                  )
                  .then((res) => {
                    this.setState({ datarequested: false });
                    window.location.reload(false);
                    this.setState({ groupconvermodal_visible: false });
                  })
                  .catch((error) => console.log(error));



                }


              }}
            >
              {" "}
              Convert
            </Button>
          </Modal>
        </div>
      );
    }
  }
}

export default MemberList;
